import { createTheme } from '@material-ui/core/styles';
import lightTheme from '../lightTheme';

const lightVentiTheme = createTheme(lightTheme, {
  ...lightTheme,
  palette: {
    ...lightTheme.palette,
    type: 'light',
    mode: 'light',
    primary: {
      main: '#FF5619',
      dark: '#7F1C0F',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#7D5BF6',
      dark: '#421D95',
      contrastText: '#FFFFFF',
    },
    footer: {
      text: '#FFFFFF',
      background: '#26272B',
    },
    header: {
      background: '#D9D9D9',
      buttonText: '#FFFFFF',
      buttonBackground: '#FF5619',
      subHeaderBackground: '#1A1A1E',
      text: '#FFFFFF',
    },
    buttons: {
      disabled: '#1D1D21',
      disabledText: '#2F3035',
      main: {
        background: '#7D5BF6',
        text: '#FFFFFF',
        hover: '#7D5BF6',
      },
      alternative: {
        background: '#000000',
        text: '#FFFFFF',
        hover: '#000000',
      },
    },
    charts: {
      primary: '#7D5BF6',
      secondary: '#BEB5FD',
      text: '#FFFFFF',
    },
  },
});

export default lightVentiTheme;
